export const OptionsBancos = [
  { label: "654 - A.J. RENNER S.A.", value: "654" },
  { label: "246 - ABC-BRASIL S.A.", value: "246" },
  { label: "213 - ARBI S.A.", value: "213" },
  { label: "19 - AZTECA DO BRASIL S.A.", value: "19" },
  { label: "25 - BANCO ALFA", value: "25" },
  { label: "241 - Banco Classico S.A", value: "241" },
  { label: "83 - BANCO DA CHINA BRASIL S.A.", value: "83" },
  { label: "300 - BANCO DE LA NACION ARGENTINA", value: "300" },
  { label: "495 - BANCO DE LA PROVINCIA DE BUENOS AIRES", value: "495" },
  { label: "494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY", value: "494" },
  { label: "1 - BANCO DO BRASIL", value: "1" },
  { label: "37 - BANCO DO ESTADO DO PARÁ S.A", value: "37" },
  { label: "456 - BANCO TOKYO MITSUBISH UFJ BRASIL S.A", value: "456" },
  { label: "370 - BANCO WESTLB DO BRASIL", value: "370" },
  { label: "756 - BANCOOB", value: "756" },
  { label: "47 - BANESE", value: "47" },
  { label: "33 - BANESPA", value: "33" },
  { label: "21 - BANESTES", value: "21" },
  {
    label: "719 - BANIF-BANCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A",
    value: "719",
  },
  {
    label: "755 - BANK OF AMERICA MERRILL LYNCH BANCO MULTIPLO S.A.",
    value: "755",
  },
  { label: "41 - BANRISUL", value: "41" },
  { label: "740 - BARCLAYS S.A.", value: "740" },
  { label: "3 - BASA", value: "3" },
  { label: "107 - BBM S.A", value: "107" },
  { label: "81 - BBN BANCO BRASILEIRO DE NEGOCIOS S.A", value: "81" },
  { label: "250 - BCV - BANCO DE CREDITO E VAREJO S.A", value: "250" },
  { label: "36 - BEM", value: "36" },
  { label: "122 - BERJ S.A", value: "122" },
  {
    label: "78 - BES INVESTIMENTO DO BRASIL SA - BANCO DE INVESTIM.",
    value: "78",
  },
  { label: "739 - BGN S.A.", value: "739" },
  { label: "320 - BIC BANCO", value: "320" },
  { label: "96 - BM&F DE SERV. DE LIQUIDACAO E CUSTODIA S.A", value: "96" },
  { label: "394 - BMC S.A.", value: "394" },
  { label: "318 - BMG S.A.", value: "318" },
  { label: "4 - BNB", value: "4" },
  { label: "752 - BNP PARIBAS BRASIL S.A", value: "752" },
  { label: "17 - BNY MELLON S.A.", value: "17" },
  { label: "248 - BOA VISTA INTERATLANTICO S.A", value: "248" },
  { label: "218 - BONSUCESSO S.A.", value: "218" },
  { label: "69 - BPN BRASIL BANCO MULTIPLO S.A", value: "69" },
  { label: "65 - BRACCE S.A.", value: "65" },
  { label: "237 - BRADESCO", value: "237" },
  { label: "225 - BRASCAN S.A.", value: "225" },
  { label: "125 - BRASIL PLURAL S.A. BANCO MULTIPLO", value: "125" },
  { label: "70 - BRB", value: "70" },
  {
    label: "92 - BRICKELL S A CREDITO, FINANCIAMENTO E INVESTIMENTO",
    value: "92",
  },
  { label: "208 - BTG PACTUAL S.A.", value: "208" },
  { label: "263 - CACIQUE S.A.", value: "263" },
  { label: "104 - CAIXA ECON. FEDERAL", value: "104" },
  { label: "473 - CAIXA GERAL - BRASIL S.A.", value: "473" },
  { label: "412 - CAPITAL S.A.", value: "412" },
  { label: "40 - CARGILL S.A", value: "40" },
  { label: "112 - CC UNICRED BRASIL CENTRAL", value: "112" },
  { label: "84 - CC UNIPRIME NORTE DO PARANA", value: "84" },
  {
    label: "114 - CECOOPES-CENTRAL DAS COOP DE ECON E CRED MUTUO DO",
    value: "114",
  },
  { label: "85 - CECREDI", value: "85" },
  { label: "266 - CEDULA S.A.", value: "266" },
  { label: "233 - CIFRA S.A.", value: "233" },
  { label: "745 - CITIBANK", value: "745" },
  { label: "477 - Citibank N.A.", value: "477" },
  { label: "90 - COOPERATIVA CENTRAL DE CREDITO DO ESTADO DE SP", value: "90" },
  {
    label: "97 - COOPERATIVA CENTRAL DE CREDITO NOROESTE BRASILEIRO",
    value: "97",
  },
  {
    label: "89 - COOPERATIVA DE CREDITO RURAL DA REGIAO DA MOGIANA",
    value: "89",
  },
  { label: "75 - CR2 S.A", value: "75" },
  { label: "98 - CREDIALIANCA COOPERATIVA DE CREDITO RURAL", value: "98" },
  { label: "222 - CREDIT AGRICOLE BRASIL S.A.", value: "222" },
  { label: "505 - CREDIT SUISSE (BRASIL) S.A.", value: "505" },
  { label: "707 - DAYCOVAL", value: "707" },
  { label: "487 - DEUTSCHE BANK S. A. - BANCO ALEMAO", value: "487" },
  { label: "214 - DIBENS S.A.", value: "214" },
  { label: "265 - FATOR S.A.", value: "265" },
  { label: "224 - FIBRA", value: "224" },
  { label: "626 - FICSA S.A.", value: "626" },
  { label: "121 - GERADOR S.A.", value: "121" },
  { label: "612 - GUANABARA S.A.", value: "612" },
  { label: "62 - HIPERCARD BANCO MULTIPLO S.A", value: "62" },
  { label: "399 - HSBC", value: "399" },
  { label: "63 - IBI", value: "63" },
  { label: "604 - INDUSTRIAL DO BRASIL S. A.", value: "604" },
  { label: "653 - INDUSVAL S.A.", value: "653" },
  { label: "492 - ING BANK N.V.", value: "492" },
  { label: "630 - INTERCAP S.A.", value: "630" },
  { label: "77 - INTERMEDIUM S.A.", value: "77" },
  { label: "249 - Investcred Unibanco", value: "249" },
  { label: "341 - ITAÚ", value: "341" },
  { label: "652 - ITAU HOLDING FINANCEIRA S.A", value: "652" },
  { label: "184 - Itaú-BBA", value: "184" },
  { label: "74 - J. SAFRA S.A.", value: "74" },
  { label: "376 - J.P. MORGAN S.A.", value: "376" },
  { label: "217 - JOHN DEERE S.A.", value: "217" },
  { label: "488 - JPMORGAN CHASE BANK", value: "488" },
  { label: "76 - KDB DO BRASIL S.A", value: "76" },
  { label: "757 - KEB DO BRASIL S.A.", value: "757" },
  { label: "600 - Luso Brasileiro", value: "600" },
  { label: "243 - MAXIMA S.A.", value: "243" },
  { label: "389 - MERCANTIL DO BRASIL", value: "389" },
  { label: "746 - MODAL S.A.", value: "746" },
  { label: "66 - MORGAN STANLEY DEAN WITTER S.A", value: "66" },
  { label: "14 - NATIXIS BRASIL S.A. - BANCO MòLTIPLO", value: "14" },
  { label: "753 - NBC BANK BRASIL S.A.- BANCO MULTIPLO", value: "753" },
  { label: "45 - OPPORTUNITY S.A.", value: "45" },
  { label: "79 - ORIGINAL DO AGRONEGOCIO S.A.", value: "79" },
  { label: "212 - ORIGINAL S.A.", value: "212" },
  { label: "623 - PANAMERICANO", value: "623" },
  { label: "254 - PARANA BANCO S.A.", value: "254" },
  { label: "611 - PAULISTA", value: "611" },
  { label: "613 - PECUNIA S.A.", value: "613" },
  { label: "94 - PETRA S.A.", value: "94" },
  { label: "643 - PINE S.A.", value: "643" },
  { label: "735 - POTTENCIAL S.A.", value: "735" },
  { label: "747 - RABOBANK INTERNATIONAL BRASIL S.A.", value: "747" },
  { label: "88 - RANDON S.A.", value: "88" },
  { label: "633 - RENDIMENTO S.A.", value: "633" },
  { label: "741 - RIBEIRÃO PRETO", value: "741" },
  { label: "120 - RODOBENS S.A", value: "120" },
  { label: "453 - RURAL", value: "453" },
  { label: "72 - RURAL MAIS S.A", value: "72" },
  { label: "422 - SAFRA", value: "422" },
  { label: "751 - SCOTIABANK BRASIL S.A BANCO MULTIPLO", value: "751" },
  { label: "743 - SEMEAR S.A.", value: "743" },
  { label: "748 - SICREDI", value: "748" },
  { label: "749 - SIMPLES S.A.", value: "749" },
  { label: "366 - SOCIETE GENERALE BRASIL S.A", value: "366" },
  { label: "637 - SOFISA S.A.", value: "637" },
  { label: "464 - SUMITOMO MITSUI BRASILEIRO S.A.", value: "464" },
  { label: "82 - TOPAZIO S.A.", value: "82" },
  { label: "634 - Triangulo", value: "634" },
  { label: "230 - UNICARD BANCO MULTIPLO S.A", value: "230" },
  {
    label: "91 - UNICRED CENTRAL RS - CENTRAL DE COOP ECON CRED MUT",
    value: "91",
  },
  { label: "87 - UNICRED CENTRAL SANTA CATARINA", value: "87" },
  {
    label: "99 - UNIPRIME CENTRAL - CENTRAL INT DE COOP DE CRED LTD",
    value: "99",
  },
  { label: "655 - VOTORANTIM", value: "655" },
  { label: "610 - VR S.A.", value: "610" },
  { label: "119 - WESTERN UNION DO BRASIL S.A.", value: "119" },
  { label: "124 - WOORI BANK DO BRASIL S.A", value: "124" },
];
